import { Stack } from '@mui/material'
import { IMilkingProcessStats } from 'models/MilkingProcess'
import { useGetMinutesFromSec } from 'utils/getMinutesFromSeconds/useGetMinutesFromSec'
import { AverageTimeCard } from './AvgTimeCard'
import { ShiftIndicatorsCard } from './ShiftIndicatorsCard'

type MilkingIndicatorsProcessProps = {
	stats: IMilkingProcessStats | undefined
	isLoading: boolean
}

export const MilkingIndicatorsProcess = (
	props: MilkingIndicatorsProcessProps,
) => {
	const milkingSeconds = props?.stats?.milking_avg
	const { morph: milkingMorph, value: milkingValue } =
		useGetMinutesFromSec(milkingSeconds)
	const connectSeconds = props?.stats?.connect_avg
	const { morph: connectMorph, value: connectValue } =
		useGetMinutesFromSec(connectSeconds)

	return (
		<Stack direction={'column'} gap={'24px'} minWidth={'360px'}>
			<ShiftIndicatorsCard stats={props?.stats} isLoading={props?.isLoading} />
			<Stack direction={'row'} gap={'24px'} height={'100%'}>
				<AverageTimeCard
					title={connectValue}
					subTitle={connectMorph}
					description={'Среднее время подключения'}
					isLoading={props?.isLoading}
				/>

				<AverageTimeCard
					title={milkingValue}
					subTitle={milkingMorph}
					description={'Среднее время доения'}
					isLoading={props?.isLoading}
				/>
			</Stack>
		</Stack>
	)
}
